import React, { useContext, useState } from "react";
import styled from "styled-components";
import { AudioPlayerContext } from "./AudioPlayerContext";
import { Pause, PlayArrowRounded } from "@mui/icons-material";

function PlaylistItem({ file, isExpanded }) {
  const {isPlaying, selectedFile, setWantsToPlay, play, setAudioAndReset} = useContext(AudioPlayerContext);
  const [duration, setDuration] = useState(0);
  const audioRef = React.useRef(null);

  const setFileAndPlay = () => {
    if (file.id === selectedFile.id) {
      return play();
    }

    if (file.id !== selectedFile.id) {
      setAudioAndReset(file.id);
    }

    setWantsToPlay(true);
  }

  return (
    <FileWrapper className={file.id === selectedFile.id ? "is-selected" : ""}>
      <FileTitle>{file.name}</FileTitle>
      { isExpanded && <TrackDurationAndControl>
        <div className="track-time">{ Math.floor(duration / 60)}:{("0" + Math.floor(duration % 60)).slice(-2)
        }</div>
        <PlayerButton className="player-control" onClick={setFileAndPlay}>
          {isPlaying && file.id === selectedFile.id ? <Pause fontSize="inherit"/> : <PlayArrowRounded fontSize="inherit"/>}
        </PlayerButton>
      </TrackDurationAndControl> }
      <audio
        preload="auto"
        ref={audioRef}
        src={file.src}
        onLoadedMetadata={() => setDuration(audioRef.current.duration)}
      >
        <track kind="metadata"/>
        <p>Your browser does not support the
          <code>audio</code> element.</p>
      </audio>
    </FileWrapper>
  );
}
const PlayerButton = styled.button`
    width: 12px;
    height: 12px;
    display: none;
    justify-content: center;
    align-items: center;
    background-color: transparent;
    color: #423F67;
    border-radius: 50%;
    border: none;
    cursor: pointer;
    font-size: 24px;
`;

const TrackDurationAndControl = styled.div`
  position: relative;
  color: #423F67;
  padding-right: 8px;
`
const FileWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 1rem;
  width: 100%;
  font-size: 16px;
  audio { display: none; }
  &:hover, &.is-selected {
    .track-time {
      display: none;
    }
    .player-control {
      display: flex;
    }
  }
`;
const FileTitle = styled.div`
  color: #423F67;
  font-family: 'Quattrocento', serif;
  font-weight: 700;
  max-width: 83%;
  flex-grow: 1;
  flex-shrink: 0;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
`

export default PlaylistItem;
